<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Galerija</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 salon-container mb-3">
					<div class="container mb-3">
						<div class="row">
							<div class="col-12 mt-3">
								<notify></notify>
							</div>
							<!-- dodaj sliku -->
							<div class="col-md-6 mb-3">
								<form>
									<div class="form-group files">
										<input type="file" @change="readImage()" id="files" class="form-control" multiple="">
									</div>
									<div class="row no-gutters">
										<div v-for="(img,index) in files" :key="index" class="col-4">
											<div v-bind:style="{ backgroundImage: 'url(' + img.src + ')' }" class="img-wrapper-gallery-up"></div>
										</div>
									</div>
									<button @click="upload()" id="submit" type="button" class="fs-btn dark text-uppercase btn-lg btn-block mt-3">
										<loader v-if="loader" color="white"></loader> <span v-if="!loader">Učitaj</span>
									</button>
								</form>
							</div>
							<!-- naslovna, profilna, istaknute -->
							<div class="col-md-6 mb-3">

								<div class="row no-gutters">
									<div class="col-6">
										<h5 class="my-3"><b>Profilna</b></h5>
										<div class="img-wrapper-gallery-pr" v-bind:style="{ backgroundImage: 'url(' + profile_picture  + ')' }"></div>
									</div>
									<div class="col-6">
										<h5 class="my-3"><b>Naslovna</b></h5>
										<div class="img-wrapper-gallery-pr" v-bind:style="{ backgroundImage: 'url(' + home_picture  + ')' }"></div>
										<!-- <div class="imgContainer">
											<div class="img-wrapper">
												<img :src="home_picture" class="img-responsive">
											</div>
										</div> -->
									</div>
									<div class="col-12 mt-3">
										<div class="row no-gutters">
											<div class="col-12">
												<h5 class="my-3"><b>Istaknute</b></h5>
											</div>
											<div v-for="(img,index) in featured_picture" :key="index" class="col-4">
												<div class="img-wrapper-gallery-ft" v-bind:style="{ backgroundImage: 'url(' + img.filename  + ')' }"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 salon-container mb-3">
					<div class="container mb-3">
						<div class="row no-gutters">
							<div class="col-12 mb-3">
								<h5 class="my-3"><b>Sve fotografije</b></h5>
								<div class="row no-gutters">
									<div v-for="(photo,index) in user.salon.images" :key="index" class="col-4 col-md-2">
									<a @click="setImage(index)">
										<div v-bind:style="{ backgroundImage: 'url(' + photo.filename + ')' }" class="img-wrapper-gallery"></div>
									</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'gallery',
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
				token: (state) => state.token,
				home_picture: (state) => state.home_picture,
				profile_picture: (state) => state.profile_picture,
				featured_picture: (state) => state.featured_picture,
			})
		},
		data() {
			return {
				files: [],
			}
		},
		methods: {
			setImage(index) {
				this.$store.state.photos = this.$store.state.user.salon.images;
				this.$store.state.image_viewer = true;
				this.$store.state.active_image = index;
				window.scrollTo(0, 0);
			},
			readImage() {
				var files = document.getElementById('files').files;

				var reader = new FileReader()

				var file = 0;
				for (var ind in files) {
					file = files[ind];
					if (typeof file != 'object') {
						continue;
					}
					let formats = ['image/png', 'image/jpg', 'image/jpeg', 'image/PNG'];

					if (!formats.find((ft => ft == file.type))) {
						alert('format slike nije podržan!');
						return false;
					}
					var data = file;
					reader.onload = (result) => {
						this.files.push({
							src: result.srcElement.result,
							data: data
						});
					}
					reader.readAsDataURL(file);
				}
			},
			upload() {
				if (this.files.length == 0) {
					return false;
				}

				this.$store.state.loader = true;
				var payload = new FormData();
				this.files.forEach((d, index) => {
					// console.log(d.data);
					payload.append('file' + index, d.data);
				});

				this.$store.dispatch('post', {
						details: payload,
						endpoint: this.endpoint + 'add-image?token=' + this.token
					})
					.then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
							this.files = [];
						}
						this.$store.state.loader = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
						this.$store.state.loader = false;
					})
			}
		},
		created() {
			this.$store.commit('sortImages');
		}
	}

</script>
<style>
	.control {
		position: absolute;
		z-index: 999999999;
		top: 0;
		bottom: 0;
		height: 100px;
		margin: auto;
	}

	.left {
		float: left;
		margin-right: 20px;
	}

	.right {
		float: right;
		margin-right: 20px;
	}

	.imagesHolder {
		display: flex;
		margin-bottom: 10px;
	}

	.img {
		background: lightgray;
		min-width: 100px;
		height: 120px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		display: block;
	}

	.fimg {
		height: 90px;
	}

	.imgContainer {
		height: 100px !important;
	}

	.st {
		background: #f41068;
	}

</style>
